import { PRIORITY_LEGEND_BG } from '../../../utils/priority';
import type { PriorityTier } from '../../../utils/priority';

interface PriorityCounts {
  strategic: number;
  recommended: number;
  opportunistic: number;
}

interface PriorityLegendProps {
  counts?: PriorityCounts;
  total?: number;
  updatedTime?: string;
}

const PRIORITY_ORDER: { tier: PriorityTier; label: string }[] = [
  { tier: 'strategic', label: 'Strategic' },
  { tier: 'recommended', label: 'Recommended' },
  { tier: 'opportunistic', label: 'Opportunistic' },
];

export default function PriorityLegend({ counts, total, updatedTime }: PriorityLegendProps) {
  return (
    <div className="ivt-sm-legend">
      {total != null && (
        <span className="ivt-sm-legend__total">Total: {total} Use Cases</span>
      )}
      {counts &&
        PRIORITY_ORDER.map(({ tier, label }) => (
          <span key={tier} className="ivt-sm-legend__item">
            <span
              className="ivt-sm-legend__swatch"
              style={{ background: PRIORITY_LEGEND_BG[tier] }}
            />
            <span>{counts[tier]} {label}</span>
          </span>
        ))}
      {updatedTime && (
        <span className="ivt-sm-legend__updated">Updated Time: {updatedTime}</span>
      )}
    </div>
  );
}
